"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  padding-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background: ", ";\n  cursor: pointer;\n  padding: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarCardRight = exports.CalendarCard = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

exports.CalendarCard = styled_components_1["default"].div(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@background-color-dark'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@text-color-dark'];
}, function (props) {
  return props.theme['@size-xxs'];
});
exports.CalendarCardRight = styled_components_1["default"].div(_templateObject2(), function (props) {
  return props.theme['@size-s'];
});